import type { BillingTranslation } from './en';

/** Urdu. Pending review by native speakers, as the note in the interface says. */
export const billingUr: BillingTranslation = {
  nav: 'پلان اور بلنگ',
  title: 'پلان اور بلنگ',
  description:
    'آپ کا پلان، اس مہینے کا استعمال، آپ کی انوائسز، اور آپ کی ای میلز پر دکھنے والا نام۔',
  loading: 'آپ کا پلان لوڈ ہو رہا ہے',
  checkout: {
    done: 'شکریہ۔ آپ کی ادائیگی کی تصدیق ہو رہی ہے، اور چند لمحوں میں آپ کا پلان بدل جائے گا۔',
    cancelled: 'آپ نے ادائیگی کا صفحہ چھوڑ دیا۔ کوئی رقم نہیں کاٹی گئی۔',
  },
  plan: {
    title: 'آپ کا پلان',
    none: 'کوئی پلان نہیں: کچھ بھی محدود نہیں',
    price: '{{price}} ماہانہ',
    provider: {
      free: 'مفت۔ زیادہ ضرورت ہو تو آپ اپ گریڈ کر سکتے ہیں۔',
      stripe: 'Stripe کے ذریعے کارڈ سے ادائیگی۔',
      whmcs: 'بل آپ کا فراہم کنندہ بھیجتا ہے۔ ادائیگی یا پلان بدلنے کے لیے کلائنٹ ایریا کھولیں۔',
      manual: 'اس سرور کی انوائس کے ذریعے بل۔',
    },
    grace:
      'ایک ادائیگی نہیں ہو سکی۔ آپ کا پلان {{date}} تک برقرار رہے گا۔ اسے برقرار رکھنے کے لیے اس سے پہلے انوائس ادا کریں؛ ورنہ ورک اسپیس مفت پلان پر چلا جائے گا۔',
    trial:
      '{{date}} تک ٹرائل۔ اس کے بعد، اگر آپ کوئی پلان نہیں چنتے، تو ورک اسپیس مفت پلان پر چلا جائے گا۔',
    renews: '{{date}} کو تجدید ہوگی۔',
    ends: '{{date}} کو ختم ہوگا۔ اس کی تجدید نہیں ہوگی۔',
  },
  status: {
    none: 'کوئی سبسکرپشن نہیں',
    trialing: 'ٹرائل',
    active: 'فعال',
    past_due: 'ادائیگی واجب',
    unpaid: 'ادائیگی نہیں ہوئی',
    canceled: 'منسوخ',
    incomplete: 'ادائیگی کا انتظار',
    paused: 'رکا ہوا',
  },
  providers: {
    free: 'مفت',
    stripe: 'Stripe',
    whmcs: 'WHMCS',
    manual: 'اس سرور کی انوائسز',
  },
  actions: {
    manage: 'بلنگ کا انتظام',
    clientArea: 'کلائنٹ ایریا کھولیں',
    upgrade: 'اپ گریڈ کریں',
    chooseLabel: '{{plan}} پر اپ گریڈ کریں',
  },
  plans: {
    title: 'پلان',
    description:
      'کوئی پلان چنیں اور محفوظ ادائیگی کے صفحے پر اس کی ادائیگی کریں۔ آپ اسے بعد میں بدل یا منسوخ کر سکتے ہیں۔',
    limit: '{{limit}}: {{value}}',
    unlimited: 'کوئی حد نہیں',
    trialDays: 'ٹرائل: {{n}} دن مفت',
    readOnly: 'پلان صرف بلنگ سنبھالنے والے لوگ بدل سکتے ہیں۔',
  },
  usage: {
    title: 'اس مہینے کا استعمال',
    details: 'تفصیلات اور AI بجٹ',
  },
  invoices: {
    title: 'انوائسز',
    loading: 'انوائسز لوڈ ہو رہی ہیں',
    number: 'انوائس',
    date: 'تاریخ',
    total: 'کل',
    status: 'حالت',
    links: 'لنکس',
    pay: 'ادائیگی کریں',
    view: 'دیکھیں',
    pdf: 'PDF',
    empty: 'ابھی کوئی انوائس نہیں۔',
    allInReports: 'تمام انوائسز',
    inClientArea: 'آپ کی انوائسز آپ کے فراہم کنندہ کے کلائنٹ ایریا میں ہیں۔',
    statuses: {
      draft: 'مسودہ',
      open: 'کھلی',
      paid: 'ادا شدہ',
      void: 'منسوخ',
      uncollectible: 'وصول نہیں ہوئی',
    },
  },
  sender: {
    title: 'ای میل بھیجنے والے کا نام',
    description:
      'اس ورک اسپیس کی ای میلز پر لوگوں کو دکھنے والا نام، جیسے دعوت نامے، رسیدیں اور ادائیگی کی اطلاعات۔',
    loading: 'بھیجنے والے کا نام لوڈ ہو رہا ہے',
    label: 'بھیجنے والے کا نام',
    hint: 'ورک اسپیس کا نام ({{name}}) استعمال کرنے کے لیے خالی چھوڑ دیں۔',
    save: 'نام محفوظ کریں',
    saved: 'بھیجنے والے کا نام محفوظ ہو گیا۔',
  },
  suspended: {
    title: 'یہ ورک اسپیس معطل ہے',
    description:
      'آپ دیکھ سکتے ہیں، لیکن کچھ بھی بدلا نہیں جا سکتا، اور آپ کی ویب سائٹ کی چیٹ آف لائن دکھتی ہے۔ اسے دوبارہ فعال کرانے کے لیے اپنے فراہم کنندہ سے رابطہ کریں۔',
  },
  provisioning: {
    queued: 'اس برانڈ کے لیے چیٹ سیٹ کی جا رہی ہے۔ اس میں تقریباً ایک منٹ لگتا ہے۔',
    running: 'چیٹ سیٹ ہو رہی ہے: {{step}}',
    failed:
      'چیٹ کا سیٹ اپ رک گیا۔ {{error}} دوبارہ کوشش کے لیے «Chatwoot سے جوڑیں» چنیں: یہ وہیں سے آگے بڑھتا ہے جہاں رکا تھا۔',
    steps: {
      account: 'اکاؤنٹ بن رہا ہے',
      integration_user: 'Hamnivo کا یوزر شامل ہو رہا ہے',
      account_user: 'Hamnivo کو رسائی دی جا رہی ہے',
      inbox: 'ان باکس بن رہا ہے',
      bot: 'AI معاون شامل ہو رہا ہے',
      bot_attached: 'AI معاون کو ان باکس سے جوڑا جا رہا ہے',
      webhook: 'اپ ڈیٹس چالو ہو رہی ہیں',
      dashboard_app: 'کوپائلٹ شامل ہو رہا ہے',
      done: 'مکمل ہو رہا ہے',
    },
  },
  signup: {
    closed:
      'اس سرور پر سائن اپ صرف دعوت سے ہوتا ہے۔ اگر آپ کو دعوت ملی ہے، تو وہی پتہ استعمال کریں جس پر دعوت بھیجی گئی تھی۔',
    closedError:
      'یہ سرور صرف مدعو پتوں کے لیے اکاؤنٹ بناتا ہے۔ وہی پتہ استعمال کریں جس پر آپ کی دعوت آئی تھی، یا دعوت مانگیں۔',
    captcha: 'تصدیق کریں کہ آپ انسان ہیں',
    captchaMissing: 'اوپر کی جانچ مکمل کریں، پھر دوبارہ کوشش کریں۔',
    captchaFailed: 'جانچ کامیاب نہیں ہوئی۔ دوبارہ کوشش کریں۔',
    captchaUnavailable:
      'جانچ لوڈ نہیں ہو سکی۔ اپنا کنکشن دیکھیں یا مواد روکنے والے ٹولز بند کریں، پھر صفحہ دوبارہ لوڈ کریں۔',
  },
  tenants: {
    suspended: 'معطل: صرف پڑھنے کے لیے',
    createClosed:
      'اس سرور پر ورک اسپیس بنانا بند ہے۔ آپ کا فراہم کنندہ انہیں بناتا ہے، یا آپ کو کسی ورک اسپیس میں مدعو کرتا ہے۔',
  },
  platform: {
    nav: 'سائن اپ اور بلنگ',
    signup: {
      title: 'عوامی سائن اپ',
      description:
        'کیا اس سرور پر کوئی بھی اکاؤنٹ اور ورک اسپیس بنا سکتا ہے۔ مدعو لوگ ہمیشہ شامل ہو سکتے ہیں۔',
      loading: 'سائن اپ کی ترتیب لوڈ ہو رہی ہے',
      open: 'سب کے لیے کھلا',
      closed: 'صرف دعوت سے',
      overridden: '{{time}} کو یہاں بدلا گیا',
      envDefault: 'سرور کی ترتیب (HAMNIVO_PUBLIC_SIGNUP): {{state}}',
      openShort: 'کھلا',
      closedShort: 'بند',
      turnstileOn: 'Cloudflare Turnstile ہر سائن اپ کی جانچ کرتا ہے۔',
      turnstileOff:
        'Cloudflare Turnstile بند ہے۔ اسے چالو کرنے کے لیے TURNSTILE_SITE_KEY اور TURNSTILE_SECRET_KEY سیٹ کریں۔',
      defaultPlan: 'نئے ورک اسپیس اس پلان سے شروع ہوتے ہیں: {{plan}}',
      unlimited: 'کوئی پلان نہیں (کچھ بھی محدود نہیں)',
      close: 'سائن اپ بند کریں',
      openIt: 'سائن اپ کھولیں',
      follow: 'سرور کی ترتیب استعمال کریں',
      needsAdmin: 'اسے صرف پلیٹ فارم ایڈمن بدل سکتے ہیں۔',
      saved: 'سائن اپ کی ترتیب محفوظ ہو گئی۔',
    },
    plans: {
      title: 'پلان',
      description:
        'بلنگ کمانڈ plan:set سے پلان شامل کریں یا بدلیں (Hamnivo کو بطور سروس چلانے کی گائیڈ دیکھیں)۔',
      loading: 'پلان لوڈ ہو رہے ہیں',
      name: 'نام',
      key: 'کلید',
      price: 'ماہانہ قیمت',
      trial: 'ٹرائل',
      stripe: 'Stripe قیمت',
      trialDays: '{{n}} دن',
    },
    keys: {
      title: 'آپریٹر API کلیدیں',
      description:
        'WHMCS جیسے بلنگ سسٹم ورک اسپیس بنانے، معطل کرنے اور بدلنے کے لیے کلید استعمال کرتے ہیں۔ کلید صرف ایک بار، بناتے وقت دکھتی ہے۔',
      loading: 'کلیدیں لوڈ ہو رہی ہیں',
      name: 'نام',
      nameHint: 'کلید کہاں استعمال ہوگی، جیسے WHMCS۔',
      nameRequired: 'کلید کو ایک نام دیں۔',
      create: 'کلید بنائیں',
      created: 'یہ کلید ابھی کاپی کریں اور بلنگ سسٹم میں رکھیں۔ یہ دوبارہ نہیں دکھے گی۔',
      copy: 'کلید کاپی کریں',
      copied: 'کلید کاپی ہو گئی۔',
      copyFailed: 'کاپی نہیں ہو سکی۔ کلید منتخب کر کے خود کاپی کریں۔',
      empty: 'ابھی کوئی کلید نہیں۔',
      prefix: 'شروعات',
      createdAt: 'بنائی گئی',
      lastUsed: 'آخری استعمال',
      status: 'حالت',
      never: 'کبھی نہیں',
      active: 'فعال',
      revoked: 'منسوخ شدہ',
      revoke: 'منسوخ کریں',
      revokeLabel: 'کلید {{name}} منسوخ کریں',
      revokeTitle: 'کلید {{name}} منسوخ کریں؟',
      revokeBody:
        'اس کلید کو استعمال کرنے والے سسٹم فوراً کام کرنا بند کر دیں گے۔ اسے واپس نہیں کیا جا سکتا۔',
      revokedDone: 'کلید منسوخ ہو گئی۔',
    },
    tenant: {
      title: 'پلان اور حالت',
      loading: 'پلان لوڈ ہو رہا ہے',
      plan: 'پلان',
      noPlan: 'کوئی پلان نہیں (کچھ بھی محدود نہیں)',
      trial: '{{date}} تک ٹرائل',
      provider: 'بل دینے والا',
      graceLabel: 'ادائیگی',
      grace: 'ناکام؛ {{date}} تک مہلت',
      usage: 'اس مدت کا استعمال',
      assign: 'پلان بدلیں',
      assignTitle: '{{name}} کا پلان بدلیں',
      planField: 'پلان',
      pickPlan: 'پلان چنیں',
      startTrial: 'پلان کا ٹرائل ({{n}} دن) شروع کریں، پھر مفت پلان پر واپس جائیں',
      stripeNote:
        'یہ ورک اسپیس Stripe سے ادائیگی کرتا ہے۔ اس کا پلان Stripe میں بدلیں، یا پہلے سبسکرپشن منسوخ کریں۔',
      assigned: 'پلان بدل گیا۔',
      suspend: 'معطل کریں',
      reactivate: 'دوبارہ فعال کریں',
      suspendTitle: '{{name}} کو معطل کریں؟',
      reactivateTitle: '{{name}} کو دوبارہ فعال کریں؟',
      suspendBody:
        'اس کے لوگ سائن ان کر کے دیکھ سکتے ہیں، لیکن کچھ بھی بدلا نہیں جا سکتا، اور اس کی ویب سائٹس کی چیٹ آف لائن دکھتی ہے۔',
      reactivateBody: 'سب کچھ دوبارہ کام کرے گا، اس کی ویب سائٹس کی چیٹ بھی۔',
      reason: 'وجہ',
      reasonHint: 'ورک اسپیس کے آڈٹ لاگ اور پلیٹ فارم آڈٹ لاگ میں درج ہوتی ہے۔',
      reasonShort: 'کم از کم 3 حروف کی وجہ لکھیں۔',
      suspendedDone: 'ورک اسپیس معطل ہو گیا۔',
      reactivatedDone: 'ورک اسپیس دوبارہ فعال ہو گیا۔',
    },
  },
};
